import { getSubPageLocation, updateURLWithPush } from 'utils/utils';
import { hidePopover } from 'redux/actions/popoverActions';

export const TYPES = {
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  TOGGLE_MODAL_SUBPAGE: 'TOGGLE_MODAL_SUBPAGE',
  SET_MODAL_CLOSING: 'SET_MODAL_CLOSING',
};

export const setModalClosing = () => ({
  type: TYPES.SET_MODAL_CLOSING,
});

export const toggleModal = (modalId = '', modalConfig = {}) => (dispatch, getState) => {
  let modal = modalId;
  let config = modalConfig;
  const isMobileBreakpoint = getState().appState.get('isMobileBreakpoint', false);

  if (modal === '') {
    const currentModalState = getState().modal;
    const currentModalConfig = (currentModalState && currentModalState.config) ? currentModalState.config : {};

    if (currentModalConfig.parentModal) {
      modal = currentModalConfig.parentModal.name;
      config = currentModalConfig.parentModal.config;
    } else if (currentModalConfig.delayClosing && !currentModalConfig.isClosing && !isMobileBreakpoint) {
      dispatch(setModalClosing());
      setTimeout(() => {
        dispatch(toggleModal(modal, config));
      }, currentModalConfig.delayClosing);
      return;
    }
  }

  if (config.forceFullHeightIfMobile) {
    config.forceFullHeight = isMobileBreakpoint;
  }

  const shouldOpenSubPageModal = config.subPageIfMobile && isMobileBreakpoint;

  if (shouldOpenSubPageModal) {
    config.isSubPage = true;
  }

  if (config.slideInFromTheSide) {
    config = Object.assign({ delayClosing: 500 }, config);
  }

  dispatch(hidePopover());

  dispatch({
    type: TYPES.TOGGLE_MODAL,
    modal,
    config,
  });

  if (shouldOpenSubPageModal) {
    const location = getState().router.location;
    updateURLWithPush(getSubPageLocation(config.subPageIfMobile, location));
  }
};


export const openSubModal = (modal, config = {}) => (dispatch, getState) => {
  const modalState = getState().modal;
  if (modalState && modalState.name) {
    config.parentModal = modalState;
  }

  dispatch(toggleModal(modal, config));
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/modalActions.js
 **/